import React, { Component } from 'react';
const firebase = window.firebase;
class FileUploadForm extends Component {

    state = {
        imgUrl: ''
    }

    componentWillMount() {
        firebase.storage().ref().child( 'images/3.JPG' ).getDownloadURL().then(url=>{
            console.log('url', url);
            this.setState({imgUrl: url})
        })
    }

    handleFile = e => {
        console.log( this.inputEl.files[0] );
        const file = this.inputEl.files[0];
        let fileName = file.name;
        firebase.storage().ref().child('images').child(fileName).put(file).then( s=> {console.log('File Uploaded')} )
    }


        
    render() {
    return (
        <div>
            <h1>My Form</h1>
            <form action="">
                <input     type="file" 
                        onChange={this.handleFile}
                        ref={el=>this.inputEl=el}
                />
            </form>
            <h1>My Image:</h1>
            <img width="400px" src={this.state.imgUrl}/>
        </div>


    );
}
}

export default FileUploadForm;


// WEBPACK FOOTER //
// ./src/FileUploadForm.js